import {JsonProperty} from '../shared/decorators/json-property';

export class TransactionNode {
  message: string;
  @JsonProperty('investment_id')
  investmentId: number;
}

export class Transaction {
  id: number;
  code: number;
  asset: string;
  volume: number;
  balance: number;
  @JsonProperty({ clazz: TransactionNode, name: 'node' })
  note: TransactionNode;
  @JsonProperty('create_time')
  time: number;
  @JsonProperty('order_id')
  orderId: number;
  constructor() {
    this.id = undefined;
    this.code = undefined;
    this.asset = undefined;
    this.volume = undefined;
    this.balance = undefined;
    this.note = new TransactionNode();
    this.time = undefined;
    this.orderId = undefined;
  }
}

export class TransactionContainer {
  username: string;
  status: number;
  asset: string;
  type: number;
  volume: number;
  login: number;
  @JsonProperty('create_time')
  time: number;
  fee: number;
  @JsonProperty('actual_volume')
  actualVolume: number;
  @JsonProperty('nominal_volume')
  nominalVolume: number;
  @JsonProperty('nominal_asset')
  nominalAsset: string;
  @JsonProperty('actual_asset')
  actualAsset: string;
  @JsonProperty('fee_asset')
  feeAsset: string;
  @JsonProperty('approved_user')
  approver: string;
  constructor() {
    this.username = undefined;
    this.status = undefined;
    this.asset = undefined;
    this.type = undefined;
    this.volume = undefined;
    this.time = undefined;
    this.approver = undefined;
    this.fee = undefined;
    this.actualVolume = undefined;
    this.actualVolume = undefined;
    this.nominalVolume = undefined;
    this.nominalAsset = undefined;
    this.actualAsset = undefined;
    this.feeAsset = undefined;
    this.login = undefined;
  }
  getType(): any {
    return this.type ? 'Withdraw' : 'Deposit';
  }

  getStatus(): any {
    switch (this.status) {
      case 1:
        return {
          name: 'Pending',
          html: '<span class="text-warning">Pending</span>',
        };
      case 2:
        return {
          name: 'Success',
          html: '<span class="text-green">Success</span>',
        };
      case 3:
        return { name: 'Error', html: '<span class="text-red">Error</span>' };
      case 4:
        return {
          name: 'Rejected',
          html: '<span class="text-red">Rejected</span>',
        };
      case 5:
        return {
          name: 'Approved',
          html: '<span class="text-primary">Approved</span>',
        };
      case 6:
        return {
          name: 'BelowMinimum',
          html: '<span class="text-primary">Below Minimum</span>',
        };
      case 7:
        return {
          name: 'NotEnoughBalance',
          html: '<span class="text-primary">Not enough balance</span>',
        };
      case 8:
        return {
          name: 'WaitMailConfirm',
          html: '<span class="text-warning">Waiting Email Confirm</span>',
        };
      case 102:
        return {
          name: 'MT5 Account unmatched',
          html: '<span class="text-red">MT5 Account unmatched</span>',
        };
      default:
        return {};
    }
  }
}

export class BitgoTransaction extends TransactionContainer {
  @JsonProperty('bitgo_transaction_id')
  id: number;
  @JsonProperty('txid')
  refId: number;
  email: string;
  rate: number;
  constructor() {
    super();
    this.id = undefined;
    this.refId = undefined;
    this.email = undefined;
    this.rate = undefined;
  }
}

export class PerfectMoneyTransaction extends TransactionContainer {
  @JsonProperty('perfect_money_transaction_id')
  id: number;
  @JsonProperty('payment_id')
  refId: number;
  @JsonProperty('is_internal')
  internal: boolean;
  email: string;
  constructor() {
    super();
    this.id = undefined;
    this.refId = undefined;
    this.internal = undefined;
    this.email = undefined;
  }
}

export class SticpayTransaction extends TransactionContainer {
  @JsonProperty('sticpay_transaction_id')
  id: number;
  @JsonProperty('payment_id')
  refId: number;
  @JsonProperty('is_internal')
  internal: boolean;
  email: string;
  constructor() {
    super();
    this.id = undefined;
    this.refId = undefined;
    this.internal = undefined;
    this.email = undefined;
  }
}

export class BankTranferTransaction extends TransactionContainer {
  @JsonProperty('bank_transfer_id')
  id: number;
  @JsonProperty('payment_id')
  refId: number;
  @JsonProperty('is_internal')
  internal: boolean;
  email: string;
  constructor() {
    super();
    this.id = undefined;
    this.refId = undefined;
    this.internal = undefined;
    this.email = undefined;
  }
}

export class WalletTransaction {
  @JsonProperty('bitgo_transaction_id')
  id: number;
  txid: number;
  status: number;
  asset: string;
  type: number;
  volume: number;
  @JsonProperty('create_time')
  time: number;
  @JsonProperty('approved_user')
  approver: string;
  constructor() {
    this.id = undefined;
    this.txid = undefined;
    this.status = undefined;
    this.asset = undefined;
    this.type = undefined;
    this.volume = undefined;
    this.time = undefined;
    this.approver = undefined;
  }

  getType(): any {
    return this.type ? 'Withdraw' : 'Deposit';
  }

  getStatus(): any {
    switch (this.status) {
      case 1:
        return {
          name: 'Pending',
          html: '<span class="text-warning">Pending</span>',
        };
      case 2:
        return {
          name: 'Success',
          html: '<span class="text-green">Success</span>',
        };
      case 3:
        return { name: 'Error', html: '<span class="text-red">Error</span>' };
      case 4:
        return {
          name: 'Rejected',
          html: '<span class="text-red">Rejected</span>',
        };
      case 5:
        return {
          name: 'Approved',
          html: '<span class="text-primary">Approved</span>',
        };
      default:
        return {};
    }
  }
}
export class BankRequest {
  id: number;
  status: number;
  login: number;
  email: string;
  asset: string;
  amount: string;
  @JsonProperty('payment_id')
  paymentId: string;
  @JsonProperty('first_name')
  firstName: string;
  @JsonProperty('middle_name')
  middleName: string;
  @JsonProperty('last_name')
  lastName: string;
  @JsonProperty('create_time')
  createTime: number;
  @JsonProperty('user_id')
  userId: number;
  @JsonProperty('bank_account_info')
  bankAccountInfo: string;
  @JsonProperty('parent_id')
  ibId: number;
  @JsonProperty('deposit_withdrawl_fee')
  withdrawFee: number;
  constructor() {
    this.id = undefined;
    this.email = undefined;
    this.asset = undefined;
    this.amount = undefined;
    this.paymentId = undefined;
    this.firstName = undefined;
    this.middleName = undefined;
    this.lastName = undefined;
    this.login = undefined;
    this.status = undefined;
    this.createTime = undefined;
    this.userId = undefined;
    this.withdrawFee = undefined;
    this.bankAccountInfo = '';
    this.ibId = undefined
  }
  getUsername(): string {
    return ((this.firstName) ? this.firstName : '') + ' ' + ((this.lastName) ? this.lastName : '');
  }
  getStatus(): string {
    const status = ['Requested', 'Pending', 'Success', 'Error', 'Rejected', 'Approved', 'Unconfirmed', 'Not enough balance', 'Waiting Email Confirm', 'Cancelled'];
    return status[this.status];
  }
}

export class SticpayTransactionRequest {
  @JsonProperty('sticpay_transaction_id')
  id: number;
  status: number;
  login: number;
  email: string;
  @JsonProperty('currency')
  asset: string;
  @JsonProperty('volume')
  amount: string;
  @JsonProperty('amount')
  actualAmount: string;
  @JsonProperty('payment_id')
  paymentId: string;
  @JsonProperty('first_name')
  firstName: string;
  @JsonProperty('middle_name')
  middleName: string;
  @JsonProperty('last_name')
  lastName: string;
  @JsonProperty('create_time')
  createTime: number;
  @JsonProperty('user_id')
  userId: number;
  @JsonProperty('bank_account_info')
  bankAccountInfo: string;
  @JsonProperty('parent_id')
  ibId: number;
  @JsonProperty('transaction_fee')
  withdrawFee: number;
  constructor() {
    this.id = undefined;
    this.email = undefined;
    this.asset = undefined;
    this.amount = undefined;
    this.actualAmount = undefined;
    this.paymentId = undefined;
    this.firstName = undefined;
    this.middleName = undefined;
    this.lastName = undefined;
    this.login = undefined;
    this.status = undefined;
    this.createTime = undefined;
    this.userId = undefined;
    this.withdrawFee = undefined;
    this.bankAccountInfo = '';
    this.ibId = undefined
  }
  getUsername(): string {
    return ((this.firstName) ? this.firstName : '') + ' ' + ((this.lastName) ? this.lastName : '');
  }
  getStatus(): string {
    const status = ['Requested', 'Pending', 'Success', 'Error', 'Rejected', 'Approved', 'Unconfirmed', 'Not enough balance', 'Waiting Email Confirm', 'Cancelled'];
    return status[this.status];
  }
}

export class ManualDepositWithdrawRequest {
  @JsonProperty('user_id')
  id: string;
  @JsonProperty('first_name')
  firstName: string;
  @JsonProperty('middle_name')
  middleName: string;
  @JsonProperty('last_name')
  lastName: string;
  email: string;
  data: any;
  constructor() {
    this.id = undefined;
    this.firstName = undefined;
    this.middleName = undefined;
    this.lastName = undefined;
    this.email = undefined;
    this.data = undefined;
  }
  getUsername(): string {
    return ((this.firstName) ? this.firstName : '')
      + ' ' + ((this.lastName) ? this.lastName : '');
  }
}

export class ExchangeTransaction {
  @JsonProperty('history_exchange_id')
  id: number;
  @JsonProperty('from_volume')
  fromVolume: number;
  @JsonProperty('to_volume')
  toVolume: number;
  @JsonProperty('fee_volume')
  fee: number;
  @JsonProperty('from_account')
  fromAccount: number;
  @JsonProperty('to_account')
  toAccount: number;
  @JsonProperty('from_asset')
  fromAsset: number;
  @JsonProperty('to_asset')
  toAsset: number;
  @JsonProperty('create_time')
  time: number;
  rate: number;
  status: number;
  constructor() {
    this.id = undefined;
    this.fromVolume = undefined;
    this.toVolume = undefined;
    this.fee = undefined;
    this.fromAccount = undefined;
    this.toAccount = undefined;
    this.fromAsset = undefined;
    this.toAsset = undefined;
    this.time = undefined;
    this.rate = undefined;
    this.status = undefined;
  }
  getStatus(): string {
    switch (this.status) {
      case 1:
        return '<span>Pending</span>';
      case 2:
        return '<span class="text-green">Success</span>';
      case 3:
        return '<span class="text-red">Error</span>';
    }
  }
}
